import { Grid, Stack } from '@mui/material'
import { useState } from 'react'
import { SanitizedTextField } from './SanitizedTextField'
import { Heading } from '../shared'

interface InternalReferenceFieldProps {
  value: string
  onChange: (value: string) => void
  error?: boolean
  helperText?: string
  onSanitizationError?: (hasError: boolean) => void
}

/**
 * Reusable Internal Reference Number field component
 */
export const InternalReferenceField = ({
  value,
  onChange,
  error = false,
  helperText = '',
  onSanitizationError
}: InternalReferenceFieldProps) => {
  const [showAsteriskWarning, setShowAsteriskWarning] = useState(false)

  const handleChange = (sanitizedValue: string) => {
    // Check if asterisks were in the input
    const hasAsterisks = sanitizedValue.includes('*')
    if (hasAsterisks) {
      setShowAsteriskWarning(true)
      // Clear warning after 3 seconds
      setTimeout(() => setShowAsteriskWarning(false), 3000)
    }

    // Remove asterisks from the sanitized value
    const cleanedValue = sanitizedValue.replace(/\*/g, '')
    onChange(cleanedValue)
  }

  const displayHelperText = showAsteriskWarning
    ? "Asterisks (*) are not allowed in this field"
    : helperText

  return (
    <Grid item xs={4.06}>
      <Stack>
        <Grid sx={{ marginBottom: '1rem' }}>
          <Heading>Internal Reference Number</Heading>
        </Grid>
        <SanitizedTextField
          label="IRN (Optional)"
          sx={{ maxWidth: '32.5%' }}
          type="text"
          autoComplete="off"
          InputLabelProps={{ shrink: true }}
          value={value}
          onChange={handleChange}
          inputProps={{ maxLength: 50 }}
          error={error || showAsteriskWarning}
          helperText={displayHelperText}
          onSanitizationError={onSanitizationError}
          maxLength={50}
        />
      </Stack>
    </Grid>
  )
}

export default InternalReferenceField
